import { render } from "./TrainingConfirmation.vue?vue&type=template&id=c170c7d8&scoped=true"
import script from "./TrainingConfirmation.vue?vue&type=script&lang=js"
export * from "./TrainingConfirmation.vue?vue&type=script&lang=js"

import "./TrainingConfirmation.vue?vue&type=style&index=0&id=c170c7d8&scoped=true&lang=css"
import "./TrainingConfirmation.vue?vue&type=style&index=1&id=c170c7d8&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c170c7d8"]])

export default __exports__